// confluence.kyobo.com:18090/pages/viewpage.action?pageId=183150560

/* /intro */
export const LOG_T_AGREEMENT = "log-t-agreement" // 서재홈 - 동의 버튼 클릭

/* /my/settings/agreement */
export const LOG_T_WITHDRAWAL = "log-t-withdrawal" // 프로필 약관 동의 내역 관리 - 철회 버튼 클릭

/* /my/settings/kyobo-purchase */
export const LOG_T_KYOBO_PURCHASE = "log-t-kyobo-purchase" // 교보문고 구매 정보 연결 관리 - (신청, 철회) 버튼 클릭

/* /(root)  */
export const LOG_T_GROUP_QLINK = "log-t-group-qlink" // home 상단 퀵링크 | #log-t-group-qlink > button

// 이달의 서재 섹션 넷스루 트레킹 수집 안되고 있었음.
// export const LOG_T_GROUP_MOTHLY_TITLE = "log-t-group-mothly-title" // home 이달의 서재 (타이틀 클릭)
// export const LOG_T_GROUP_MOTHLY_LIFE_SENTENCE = "log-t-group-mothly-life-sentence" // home 이달의 서재 (인생문장 클릭)

export const LOG_T_GROUP_SENTENCE_CHIP = "log-t-group-sentence-chip" // home 문장칩

/* /sentences/today-pick */
export const LOG_T_TODAY_SENTECE_PICK = "log-t-today-sentence-pick" // 오늘의 문장 뽑기
export const LOG_T_TODAY_SENTECE_SAVE = "log-t-today-sentence-save" // 오늘의 문장 저장하기

/* /chips/[id] */
export const LOG_T_SENTENCE_CHIP_OPEN = "log-t-sentence-chip-open" // 문장칩 오픈
export const LOG_T_SENTENCE_CHIP_BOOK_DETAIL = "log-t-sentence-chip-book-detail" // 문장칩 도서 자세히 보기
export const LOG_T_SENTENCE_CHIP_BOOK_ON_THE_SHELF =
  "log-t-sentence-chip-book-on-the-shelf" // 문장칩 서재에 담기
export const LOG_T_SENTENCE_CHIP_NEXT = "log-t-sentence-chip-next" // 문장칩 다음 문장칩 보기
/* /chips */
export const LOG_T_GROUP_SENTENCE_CHIP_GRID = "log-t-group-sentence-chip-grid"

/* /bookshelf */
export const LOG_T_SHELF_BY_CAMERA_START = "log-t-shelf-by-camera-start" // 책장 촬영으로 등록하기
export const LOG_T_SHELF_BY_CAMERA_END = "log-t-shelf-by-camera-end" // 도서 nn권 내 서재에 등록
export const LOG_T_SHELF_BY_CAMERA_FAIL = "log-t-shelf-by-camera-fail" // 도서 nn권 내 서재에 등록 취소

export const LOG_T_SHELF_BY_SEARCH_START = "log-t-shelf-by-search-start" // 도서 출처 검색으로 등록하기
export const LOG_T_SHELF_BY_ISBN_START = "log-t-shelf-by-isbn-start" // 도서 바코드로 등록하기
export const LOG_T_SHELF_BY_PURCHASE_CONNECT = "log-t-shelf-by-purchase-connect" // 도서구매정보연결

/* /my/profile/sentences */
export const LOG_T_PROFILE_LIFE_SENTECE_REGISTER =
  "log-t-profile-life-sentence-register" // 나의 프포필 인생 문장 등록 하기

/* /challenges/[id] */
export const LOG_T_CHALLENGE_PATICIPATION = "log-t-challenge-paticipation" // 챌린지 참여하기
export const LOG_T_CHALLENGE_ROUND_SUCCESS = "log0t-challenge-round-success" // 오늘의 챌린지 참여 완료

/* /sentence/write */
export const LOG_T_SENTENCE_WRITE_BY_OCR = "log-t-sentence-write-by-ocr" // OCR로 글쓰기 시도
export const LOG_T_SENTENCE_CREATE_TRY = "log-t-sentence-create-try" // 문장 생성 시도

export const LOG_T_GNB_HOME = "log-t-gnb-home"
export const LOG_T_GNB_SHELF = "log-t-gnb-shelf"
export const LOG_T_GNB_SENTENCE_PLAY = "log-t-gnb-sentence-play"
export const LOG_T_GNB_COMMUNITY = "log-t-gnb-community"
export const LOG_T_GNB_BACK_KYOBORO = "log-t-gnb-back-kyoboro"

/* 공용 */
export const LOG_T_FOLLOW = "log-t-follow" // 팔로우
export const LOG_T_F4F = "log-t-f4f" // 맞팔로우
